import { render, staticRenderFns } from "./item-resources.vue?vue&type=template&id=b80808c4&"
import script from "./item-resources.vue?vue&type=script&lang=js&"
export * from "./item-resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports